import axios from "axios";
import { MonitorLiveDaMesItaltexModel, MonitorLiveDaMesModel } from "./models";

const API_URL = process.env.REACT_APP_API_URL;
const GET_MONITOR_LIVE = `${API_URL}/gantt/monitor`;
const GET_MONITOR_LIVE_PUBLIC_HD = `${API_URL}/gantt/monitor-public`;
const GET_MONITOR_LIVE_PRESSE_LAST_VALUES = `${API_URL}/gantt/presse-last-values`;
const GET_MONITOR_LIVE_PRESSE_API_LOGS = `${API_URL}/gantt/api40-log`;

export function getMonitorLive(view?: string | null) {
  return axios.get<MonitorLiveDaMesModel[]>(`${GET_MONITOR_LIVE}?view=${view}`);
}

export function getMonitorLivePublic(
  view?: string | null,
  token?: string | null
) {
  return axios.get<MonitorLiveDaMesModel[]>(
    `${GET_MONITOR_LIVE_PUBLIC_HD}?view=${view}&t=${token}`
  );
}

export function getMonitorLiveItaltex(view?: string | null) {
  return axios.get<MonitorLiveDaMesItaltexModel[]>(
    `${GET_MONITOR_LIVE}?view=${view}`
  );
}

export function getMonitorLivePresseLastValuesItaltex() {
  return axios.get<any>(GET_MONITOR_LIVE_PRESSE_LAST_VALUES);
}

export function getMonitorLivePresseApiLogsItaltex() {
  return axios.get<any>(GET_MONITOR_LIVE_PRESSE_API_LOGS);
}
